import { action, makeObservable, toJS } from 'mobx'

import { assignExceptNullable, typeSafeAssign } from '@/utils/common'

export class DTO {
  constructor() {
    makeObservable(this, {
      update: action,
      updateExceptNullable: action,
      toJS: action,
    })
  }

  update<T>(this: T, ...args: Partial<T>[]) {
    typeSafeAssign(this, ...args)
    return this
  }

  // null, undefined 값이 아닌 값들만 update
  updateExceptNullable<T>(this: T, ...args: Partial<T>[]) {
    assignExceptNullable(this, ...args)
    return this
  }

  toJS<T>(this: T) {
    return toJS(this)
  }
}
